import {
    LOGGED_IN,
    LOGGED_OUT,
    RECEIVE_CART_AND_USER_PROFILE,
} from '../actions/types';

const user = (state = null, action) => {
    switch (action.type) {
        case LOGGED_IN:
            return action.payload;
        case LOGGED_OUT:
            return null;
        case RECEIVE_CART_AND_USER_PROFILE:
            return {
                ...state,
                phoneNumber: action.payload && action.payload.phone,
            };
        default:
            return state;
    }
};

export default user;
